export function getTeaserImageURL(href, scale = 'teaser') {
  return `${href['@id']}/@@images/image/${scale}`;
}
